/*
const flatteningProcessors = [
    valueIsUndefined
];

// Processor that runs only for nulls and undefined values.
const valueIsUndefined = (result, name, value) => {
    return {
        isApplicable: function () {
            return value === null || value === undefined;
        },

        apply: function() {
            // modify result as needed...
            return result;
        }
    }
};
*/

/**
 * Returns whether specified value is an ObservableArray.
 * @param {any} value
 * @return {boolean}
 */
function isObservableArray(value) {
    return (
        value.__proto__ !== undefined &&
        value.__proto__.constructor.name.match('ObservableArray')
    );
}

/**
 * Returns whether specified value is an Array or an ObservableArray.
 * @param {any} value
 * @return {boolean}
 */
function isArray(value) {
    return Array.isArray(value) || isObservableArray(value);
};

/**
 * Returns whether specified value can be flattened.
 * Strings and numbers are not flattenable.
 *
 * @param {any} value
 * @return {boolean}
 */
function isFlattenable(value) {
    return (
        typeof value !== 'string' &&
        typeof value !== 'number'
    );
}

export default function flattenConfigurationModel(model) {
    const flatten = model => {
        if (!isFlattenable(model)) {
            return model;
        }

        /*
        TODO: Rewrite all those ifs into something more like this?

        let result = {};

        for (let [name, value] of Object.entries(model)) {
            flatteningProcessors.forEach(processorFn => {
                let processorInstance = processorFn(result, name, value);
                if (processorInstance.isApplicable()) {
                    result = {
                        result,
                        ...processorInstance.apply()
                    }
                }
            });
        }

        return result;
        */

        let result = {};

        for (let [name, value] of Object.entries(model)) {
            if (value === null || value === undefined) {
                continue;
            } else if (value.type === 'list') {
                result[name] = value.items;
            } else if (typeof value.value !== 'undefined') {
                result[name] = value.value;
            } else {
                if (isArray(value)) {
                    let a = value.map(x => flatten(x)).filter(x => x !== null);
                    if (a.length !== 0) {
                        result[name] = a;
                    }
                } else if (typeof value === 'object') {
                    let flattened = flatten(value);
                    if (flattened === null) {
                        continue;
                    }

                    result[name] = flattened;
                } else {
                    result[name] = value;
                }
            }
        }

        return Object.getOwnPropertyNames(result).length !== 0 ? result : null;
    };

    return flatten(model);
}
